module.exports = __webpack_public_path__ + "static/img/h4-2.91d272e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner1/h4-2.png
// module id = 7UYR
// module chunks = 1